module.exports = __webpack_public_path__ + "036dc584d436f9b180f626c3da785b94.pdf";